var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('a',{attrs:{"href":"https://boomerangweb.net","target":"_blank"}},[_vm._v(" Boomerang Web ")]),_c('span',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" TDCLIC. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }